module.exports = __webpack_public_path__ + "img/BKM_Neustart.851165c7.jpg";